var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"space"},[_vm._v(" 空格占位，渲染时不显示 ")])}
var staticRenderFns = []

export { render, staticRenderFns }